
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/palette",
      function () {
        return require("private-next-pages/system/palette.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/palette"])
      });
    }
  